import idTranslation from "./id/translation.json";
import idZodTranslation from "./id/zod.json";

import enTranslation from "./en/translation.json";
import enZodTranslation from "./en/zod.json";

export const locales = {
  id: { translation: idTranslation, zod: idZodTranslation },
  en: { translation: enTranslation, zod: enZodTranslation },
};
